import { lazy } from "react";
import { createBrowserRouter, Navigate } from "react-router";

import { RequireAuth } from "@/components/layout/require-auth";
import { RootErrorBoundary } from "@/routes/root-error-boundary";

const DashboardLayout = lazy(() => import("@/components/layout/dashboard-layout"));
const LoginPage = lazy(() => import("@/features/auth/components/login-page"));
const MasterDataRoutes = lazy(() => import("@/features/master-data/routes"));
const PlanogramIntelligenceRoutes = lazy(() => import("@/features/planogram-intelligence/routes"));
const MissionControlRoutes = lazy(() => import("@/features/mission-control/routes"));
const RetailAiAgentRoutes = lazy(() => import("@/features/retail-ai-agents/routes"));
const NotFound = lazy(() => import("@/routes/not-found"));

export const router = createBrowserRouter([
  {
    path: "/login",
    element: <LoginPage />,
    errorElement: <RootErrorBoundary />,
  },
  {
    path: "/",
    element: (
      <RequireAuth>
        <DashboardLayout />
      </RequireAuth>
    ),
    errorElement: <RootErrorBoundary />,
    children: [
      { index: true, element: <Navigate replace to="/mission-control" /> },
      { path: "master-data/*", element: <MasterDataRoutes /> },
      { path: "mission-control/*", element: <MissionControlRoutes /> },
      { path: "planogram-intelligence/*", element: <PlanogramIntelligenceRoutes /> },
      { path: "retail-ai-agents/*", element: <RetailAiAgentRoutes /> },
    ],
  },
  { path: "*", element: <NotFound /> },
]);
